import { render } from "./ReclamationPage.vue?vue&type=template&id=087c40a3&scoped=true&ts=true"
import script from "./ReclamationPage.vue?vue&type=script&lang=ts"
export * from "./ReclamationPage.vue?vue&type=script&lang=ts"

import "./ReclamationPage.vue?vue&type=style&index=0&id=087c40a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087c40a3"]])

export default __exports__